class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {

    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (event.target.classList.contains("header-custom__drawer")) {
      const target = event.target;
      const mostParent = target.closest('#menu-drawer');
      mostParent.querySelector(".megamenu-images").classList.add("hidden");
      mostParent
        .querySelector(".menu-drawer__inner-container")
        .classList.add("full-height");
    }
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (document.querySelector(".header-search-input.header-custom__drawer")) {
      const target = document.querySelector(
        ".header-search-input.header-custom__drawer",
      );
      const mostParent = target.closest("#menu-drawer");
      mostParent.querySelector(".megamenu-images").classList.remove("hidden");
      mostParent
        .querySelector(".menu-drawer__inner-container")
        .classList.remove("full-height");
        document.querySelector(".search-modal__content.searched")?.classList.remove("searched");
      const predSearch = document.querySelector("predictive-search");
      if(predSearch) {
        predSearch.close(true)
      };
    }
  }
}

customElements.define('details-modal', DetailsModal);
